import { PlycaDataService } from '../../../../../services/plyca.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SignatureComment } from '../../models/signature/signature-comment.model';
import { Configuration } from '../../../../conf/app.constants';
import { SignatureCommentNormalizer } from '../../../../_infrastructure/adapters/normalizers/signature/signature-comment.normalizer';
import { SignatureCommentsListDTO } from '../../../../api/plyca-dtos';

@Injectable({
  providedIn: 'root',
})
export class CommentsService {
  constructor(private plycaService: PlycaDataService, private configuration: Configuration) { }

  getComments(): Observable<SignatureComment[]> {
    const url = this.configuration.SIGNATURE_COMMENTS_GENERAL_SERVICE_URL;

    return this.plycaService.get<SignatureCommentsListDTO>(url, '').pipe(
      map((response) => {
        if (!response || !response.suggestedComments) {
          return [];
        }
        return SignatureCommentNormalizer.normalizeList(response.suggestedComments);
      })
    );
  }
}
